import { useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import UserContext from "../context/UserContext";

function useLogout() {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const logout = useCallback(() => {
    Cookies.remove("accessToken");
    setUser({ isAuth: false });
    navigate("/login");
  }, [setUser, navigate]);

  return logout;
}

export default useLogout;
